import NotFound from '@/views/not-found'
import Login from '@/views/login'
import Signup from '@/views/signup'
import Confirm from '@/views/confirm'
import Confirmation from '@/views/confirmation'
import ForgotPassword from '@/views/forgot-password'
import ResetPassword from '@/views/reset-password'
import Dashboard from '@/views/dashboard'
import Profile from '@/views/profile'
import Reports from '@/views/reports'
import AddFunds from '@/views/add-funds'
import Referrals from '@/views/referrals'
import Analytics from '@/views/analytics'
import Openpay from '@/views/openpay'
import CsdsIndex from '@/views/csds/index.vue'

import * as child from './children'
let children = [
  {
    path: '/analytics',
    name: 'analytics',
    component: Analytics,
    meta: { requiresAuth: true, auth: { model: 'Dashboard', permission: 'read' } }
  },
  {
    path: '/profile',
    name: 'profile',
    component: Profile,
    meta: { requiresAuth: true, auth: { model: 'User', permission: 'read' } }
  },
  {
    path: '/',
    name: 'home',
    component: Dashboard,
    meta: { requiresAuth: true, auth: { model: 'Dashboard', permission: 'read' } }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: { requiresAuth: true, auth: { model: 'Dashboard', permission: 'read' } }
  },
  {
    path: '/credits',
    name: 'addFunds',
    component: AddFunds,
    meta: { requiresAuth: true, auth: { model: 'Dashboard', permission: 'read' } }
  },
  {
    path: '/referrals',
    name: 'referrals',
    component: Referrals,
    meta: { requiresAuth: true, auth: { model: 'Dashboard', permission: 'read' } }
  },
  {
    path: '/openpay',
    name: 'openpay',
    component: Openpay,
    meta: { requiresAuth: true, auth: { model: 'Dashboard', permission: 'read' } }
  },
  {
    path: '/csds',
    name: 'csds',
    component: CsdsIndex,
    meta: { requiresAuth: true, auth: { model: 'Csd', permission: 'read' } }
  }
]
for (let key in child) {
  children = children.concat(child[key])
}

export default [
  { path: '/login', name: 'login', component: Login },
  { path: '/logout', name: 'logout', meta: { requiresAuth: true } },
  { path: '/signup', name: 'signup', component: Signup, meta: {} },
  { path: '/confirmation', name: 'confirmation', component: Confirmation },
  { path: '/confirm', name: 'confirm', component: Confirm },
  { path: '/forgot-password', name: 'forgotPassword', component: ForgotPassword },
  { path: '/reset-password', name: 'resetPassword', component: ResetPassword },
]
  .concat(children)
  .concat([
    {
      path: '/reports',
      name: 'reports',
      component: Reports,
      meta: { requiresAuth: true, auth: { model: 'Report', permission: 'read' } }
    }
  ])
  .concat([{ path: '*', component: NotFound }])
